var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"building"},[_c('div',{staticClass:"building__content"},[_c('div',{staticClass:"building__icon",domProps:{"innerHTML":_vm._s(_vm.buildingIcon)}}),_c('p',{staticClass:"building__txt"},[_vm._v("系统升级中")]),_c('p',{staticClass:"building__des"},[_vm._v("维护时间: 2023-06-15 19:00 至 2023-06-16 08:02")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }